import { render, staticRenderFns } from "./EmisorConfig.vue?vue&type=template&id=1931208c"
import script from "./EmisorConfig.vue?vue&type=script&lang=js"
export * from "./EmisorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports